export default __webpack_public_path__ + "static/media/search.bfa1c82b.svg";